
/**
 * A replacer that omits some common defaults and null values when serializing
 * domain models.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
 */
export const omitDefaults = (key: string, value: any) => {
    const type = typeof value;
    switch(type) {
        case 'number':
        case 'string':
        case 'boolean':
            return value;
    }
    if(Array.isArray(value) && value.length == 0) {
        return undefined;
    }
    if(key == 'position' || key == 'rotation') {
        let { x, y, z } = value;
        if(x == 0) x = undefined;
        if(y == 0) y = undefined;
        if(z == 0) z = undefined;
        if(x == undefined && y == undefined && z == undefined) return undefined;
        return { x, y, z };
    }
    if(key == 'scale') {
        let { x, y, z } = value;
        if(x == 1) x = undefined;
        if(y == 1) y = undefined;
        if(z == 1) z = undefined;
        if(x == undefined && y == undefined && z == undefined) return undefined;
        return { x, y, z };
    }
    if(value == null) {
        return undefined;
    }

    return value;
}
export default omitDefaults;
